import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import marketplaceReducer from './marketplaceReducer';
import userReducer from './userReducer';
import authReducer from './authReducer';
import investmentsReducer from './investmentsReducer';
import portfolioBuilderReducer from './portfolioBuilderReducer';
import baseReducer from './baseReducer';
import statisticsReducer from './statisticsReducer';
import apiReducer from './apiReducer';
import transactionsReducer from './transactionsReducer';
import workspacesReducer from './workspacesReducer';
import userRoleReducer from './userRoleReducer';

const baseDataPersistConfig = {
  key: 'baseData',
  storage,
  whitelist: ['isAsideMenuOpen', 'preselectedAllocationId']
};

const workspacesPersistConfig = {
  key: 'workspaces',
  storage,
  whitelist: ['selected']
};

const userPersistConfig = {
  key: 'userRole',
  storage,
  whitelist: ['role']
};

const persistedBaseReducer = persistReducer(baseDataPersistConfig, baseReducer);
const persistedWorkspacesReducer = persistReducer(workspacesPersistConfig, workspacesReducer);
const persistedUserRoleReducer = persistReducer(userPersistConfig, userRoleReducer);

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  userRole: persistedUserRoleReducer,
  baseData: persistedBaseReducer,
  marketplace: marketplaceReducer,
  investments: investmentsReducer,
  portfolioBuilder: portfolioBuilderReducer,
  statistics: statisticsReducer,
  transactionsData: transactionsReducer,
  api: apiReducer,
  workspaces: persistedWorkspacesReducer
});
